
const ExperienceModes = {
    HOME_PAGE: 'HomePage',
    ADD_ITEM: 'AddItemModal',
    EDIT_ITEM: 'EditItemModal'
}


export default ExperienceModes;